const sectionEditFormButtons = {
    save: 'ZAPISZ ZMIANY',
    cancel: 'WRÓĆ'
};

export default sectionEditFormButtons;